const resourceQueryKeys = {
  folders: (parentId, fabricUser) => [
    "infinite-resource-folders",
    parentId,
    fabricUser ? "fabricUser" : void 0
  ],
  resourceDetail: (resourceId, accessToken) => [
    "resource-detail",
    resourceId || null,
    accessToken || null
  ],
  resourceBySharedSecret: (secret) => [
    "shared-resource",
    secret
  ],
  resourceList: (options) => [
    "resource-list",
    options || null
  ],
  resourceContextSearchList: (options) => [
    "resource-list-context-search",
    options || null
  ],
  resourceContextSearchExternalList: (options) => [
    "resource-list-context-search-external",
    options || null
  ],
  totals: (parentId) => [
    "resource-totals-v2",
    parentId
  ]
};

export { resourceQueryKeys };
//# sourceMappingURL=resourceQueryKeys.js.map
